import { Configuration, PopupRequest } from "@azure/msal-browser";
import config from './Config/environments';

export const msalConfig: Configuration = {
    auth: {
        clientId: config.msalConfig.clientId,
        authority: config.msalConfig.authority,
        redirectUri: config.msalConfig.redirectUri,
        postLogoutRedirectUri: config.msalConfig.postLogoutRedirectUri
    },
    cache: {
        cacheLocation: "sessionStorage",
        storeAuthStateInCookie: false,
    },
    system: {
        loggerOptions: {
            loggerCallback: (level, message, containsPii) => {
                if (containsPii) {
                    return;
                }
                switch (level) {
                    case 0:
                        console.error(message);
                        return;
                    case 1:
                        console.warn(message);
                        return;
                    case 2:
                        return;
                    case 3:
                        console.debug(message);
                        return;
                }
            }
        }
    }
};

export const loginRequest: PopupRequest = {
    scopes: ["User.Read"]
};

export const graphConfig = {
    graphMeEndpoint: "https://graph.microsoft.com/v1.0/me"
};

export const apiRequest: PopupRequest = {
    scopes: [`api://${msalConfig.auth.clientId}/access_as_user`]
};

export const apiConfig = {
    webApiUri: `${config.apiBaseUrl}/employees`
};